import { NgModule } from '@angular/core';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import {
    HTTP_INTERCEPTORS,
    HttpClient,
    HttpClientModule,
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxsModule } from '@ngxs/store';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { AuthState } from './store/auth/auth.state';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { MainState } from './store/main/main.state';
import {
    AuthInterceptor,
    BrandInterceptor,
    ResponseInterceptor,
} from './core/intercepters';
import { RefreshJwtInterceptor } from './core/intercepters/refresh.interceptor';
import { environment } from '../environments/environment';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import {
    provideTranslateHttpLoader,
    TranslateHttpLoader,
} from '@ngx-translate/http-loader';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { BranchesState } from './store/branches/state/branches/branches.state';
import { ProductsState } from './store/products/state/products/products.state';

@NgModule({
    providers: [
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RefreshJwtInterceptor,
            multi: true,
        },
        { provide: HTTP_INTERCEPTORS, useClass: BrandInterceptor, multi: true },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ResponseInterceptor,
            multi: true,
        },
        provideTranslateHttpLoader({
            prefix: './assets/i18n/',
            suffix: `.json?v=${environment.version}`,
        }),
        MessageService,
    ],
    declarations: [AppComponent],
    imports: [
        AppRoutingModule,
        BrowserModule,
        FormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        NgxsModule.forRoot(
            [AuthState, BranchesState, MainState, ProductsState],
            {
                developmentMode: !environment.production,
            },
        ),
        NgxsStoragePluginModule.forRoot({
            key: ['auth', 'main'],
        }),
        NgxsReduxDevtoolsPluginModule.forRoot({
            disabled: environment.production,
        }),
        NgxsLoggerPluginModule.forRoot({
            disabled: environment.production,
        }),
        TranslateModule.forRoot({
            defaultLanguage: 'en',
            loader: {
                provide: TranslateLoader,
                useClass: TranslateHttpLoader,
            },
        }),
        ToastModule,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
